import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { DialogContent, Stack } from "@mui/material";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useCallback, useState } from "react";

import { BottomSheetHeader } from "../components/BottomSheetHeader";
import { Button } from "../components/Button";
import { DialogFooter } from "../components/DialogFooter";

interface DatePickerInputBottomSheetProps {
  modalState: UseModalState;
  initialDate?: Date;
  onConfirm: (date: Date) => void;
}

export function DatePickerInputBottomSheet(props: DatePickerInputBottomSheetProps) {
  const { modalState, initialDate, onConfirm } = props;

  const [selectedDate, setSelectedDate] = useState<Date | undefined>(initialDate);

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      disableSwipeArea
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            variant="contained"
            disabled={!isDefined(selectedDate)}
            onClick={() => {
              if (!selectedDate) {
                return;
              }

              onConfirm(selectedDate);
            }}
          >
            Confirm
          </Button>
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
    >
      <DialogContent>
        <Stack width="100%" spacing={4} alignItems="center">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateCalendar
              value={selectedDate}
              onChange={(newDate: Date | undefined) => {
                if (isDefined(newDate)) {
                  setSelectedDate(newDate);
                }
              }}
            />
          </LocalizationProvider>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
